import { Component, inject } from '@angular/core';
import { AdminConfirmDialogComponent } from './admin-confirm-dialog.component';
import { AdminConfirmDialogService } from './admin-confirm-dialog.service';

@Component({
  selector: 'app-admin-confirm-dialog-host',
  standalone: true,
  imports: [AdminConfirmDialogComponent],
  template: `
    @if (dialog.state(); as s) {
      <app-admin-confirm-dialog
        [open]="s.open"
        [title]="s.title ?? 'Confirm'"
        [message]="s.message"
        [confirmLabel]="s.confirmLabel ?? 'Confirm'"
        [cancelLabel]="s.cancelLabel ?? 'Cancel'"
        [confirmVariant]="s.confirmVariant ?? 'primary'"
        [commentRequired]="s.commentRequired ?? false"
        [busy]="s.busy"
        [error]="s.error"
        (confirmed)="dialog.resolve(true)"
        (cancelled)="dialog.resolve(false)"
      />
    }
  `,
})
export class AdminConfirmDialogHostComponent {
  readonly dialog = inject(AdminConfirmDialogService);
}
